module.exports = fox._r("fonts/ropasoftpro-extrabolditalic-webfont.woff", __webpack_public_path__ + "fonts/2K4Rukk.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/ropasoftpro-extrabolditalic-webfont.woff
// module id = 958
// module chunks = 4